import { render } from "./DebriyajCatali.vue?vue&type=template&id=0aa94a5e"
import script from "./DebriyajCatali.vue?vue&type=script&lang=js"
export * from "./DebriyajCatali.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__